var map = {
	"./graph-common.png": 163,
	"./graph-kitchen.png": 164,
	"./graph-office.png": 165,
	"./graph-reactor.png": 166,
	"./graph-workshop-lab.png": 167,
	"./rooms.png": 168
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1013;